import Path from 'assets/icons/base/Path';
import React from 'react';
import SVG from 'assets/icons/base/SVG';

type Props = {
    color?: string;
    height?: string | string[];
    viewBox?: string;
    width?: string | string[];
};

const GaranIcon = ({ color = '#0b4f9e', height = '18px', viewBox = '0 0 13 18', width = '13px', ...props }: Props) => (
    <SVG height={height} viewBox={viewBox} width={width} fill="none" {...props}>
        <Path
            fill={color}
            d="M.18.176v14.29c0 .63.34 1.186.837 1.373l5.1 1.914c.25.093.517.095.767.004l5.087-1.833c.504-.182.85-.742.85-1.378V.176z"
        />
        <Path
            fill="#fff"
            d="M0 14.465V0h13v14.546c0 .69-.376 1.33-.967 1.543l-5.086 1.833a1.28 1.28 0 0 1-.894-.005l-5.1-1.914C.369 15.783 0 15.15 0 14.465m.359 0c0 .576.31 1.055.722 1.21l5.1 1.913c.21.079.432.08.64.004h.001l5.087-1.833c.416-.15.732-.631.732-1.213V.352H.36z"
        />
        <Path
            fill="#faea26"
            d="m6.018 5.818.483-.346.482.346-.183-.559.49-.344h-.604l-.185-.566-.186.566h-.604l.49.344zM3.518 6.475 4 6.131l.483.344-.184-.558.49-.345h-.604L4 5.006l-.185.567-.604-.001.49.345zM2.173 6.802l-.185.566h-.605l.49.345-.184.558.484-.345.482.345-.184-.558.49-.345h-.603zM1.502 10.37l.482.347-.184-.56.491-.344h-.604l-.185-.566-.186.567H.71l.491.344-.184.559zM2.358 12.265l-.185-.564-.185.566-.605-.002.49.346-.184.56.484-.348.482.347-.184-.559.49-.346zM4.19 14.06l-.185-.564-.185.566-.605-.002.49.346-.183.558.483-.345.482.345-.183-.558.49-.346zM6.686 14.712l-.185-.566-.185.566h-.604l.49.344-.183.56.482-.347.482.346-.183-.559.49-.344zM9.182 14.06l-.185-.564-.185.566-.604-.002.49.346-.183.558.482-.345.484.345-.184-.558.49-.346zM11.016 12.265l-.186-.564-.185.566-.605-.002.491.346-.184.56.483-.348.483.347-.184-.559.49-.346zM12.284 9.806h-.606l-.185-.566-.185.567-.604-.001.49.346-.183.558.482-.346.484.345-.184-.557zM10.347 8.263l.483-.344.483.344-.184-.558.49-.344h-.603l-.186-.566-.185.566h-.605l.491.344zM9.005 5.007l-.185.566-.605-.001.49.345-.184.56.485-.346.482.345-.184-.559.491-.345H9.19z"
        />
        <Path
            fill="#fff"
            d="M5.196 12.415A3.46 3.46 0 0 1 3.71 9.897l-.146-1.56 1.389-.627c.42-.19.871-.316 1.334-.342a3.6 3.6 0 0 1 1.696.314l1.452.656-.06.638-.372-.033.035-.368-1.166-.54-.088-.038a3.2 3.2 0 0 0-1.475-.262 3.4 3.4 0 0 0-1.193.306l-1.154.52.12 1.304c.084.906.569 1.727 1.327 2.252l1.102.763 1.078-.763a3.1 3.1 0 0 0 1.266-1.865l.044-.188H6.5v-.366h2.808l-.018.2a3.46 3.46 0 0 1-1.483 2.517l-1.307.904-1.306-.903z"
        />
    </SVG>
);

export default GaranIcon;
